var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiPortalNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 10.98C19.9263 12.541 19.9263 15.074 18.3643 16.636L12.7073 22.293C12.3173 22.683 11.6833 22.683 11.2933 22.293L5.63634 16.636C4.07434 15.074 4.07434 12.541 5.63634 10.979C7.19834 9.417 9.73134 9.417 11.2933 10.979L11.9993 11.686L12.7073 10.979C14.2693 9.417 16.8023 9.417 18.3643 10.979V10.98ZM7.05034 12.392C6.27034 13.173 6.27034 14.44 7.05034 15.221L12.0003 20.171L16.9503 15.221C17.7303 14.44 17.7303 13.173 16.9503 12.392C16.1693 11.612 14.9023 11.612 14.1203 12.394L11.9983 14.512L9.87834 12.392C9.09834 11.612 7.83134 11.612 7.05034 12.392V12.392ZM12.0003 1C14.2103 1 16.0003 2.79 16.0003 5C16.0003 7.21 14.2103 9 12.0003 9C9.79034 9 8.00034 7.21 8.00034 5C8.00034 2.79 9.79034 1 12.0003 1ZM12.0003 3C10.8953 3 10.0003 3.895 10.0003 5C10.0003 6.105 10.8953 7 12.0003 7C13.1053 7 14.0003 6.105 14.0003 5C14.0003 3.895 13.1053 3 12.0003 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiPortalNav);
export default __webpack_public_path__ + "static/media/miPortalNav.caedaf1eaf24f10d2354b78f1618ed16.svg";
export { ForwardRef as ReactComponent };